export default "__VITE_ASSET__BH43uRP4__"